export type TDealsBannerVariant = 'sell' | 'buy' | 'complex-deal';

export interface IDealsArticleConfig {
  formTitle: string;
  formSubtitle: string;
  bannerVariant?: TDealsBannerVariant;
}

/**
 * Реальный список 12 id статей (подтверждён заказчиком), formTitle/formSubtitle — заглушки.
 * bannerVariant пока не проставлен ни у одной статьи (открытый вопрос 1 в спеке: разбивка
 * 8 с баннером / 4 без баннера и выбор варианта sell/buy/complex-deal для каждой из 8
 * ещё не согласована с заказчиком) — до уточнения все 12 статей рендерятся без DealsBanner,
 * только с DealsLeadForm в конце.
 * См. docs/superpowers/specs/2026-08-14-deals-banner-ab-test-design.md, открытые вопросы 1 и 3.
 */
export const DEALS_CONTENT_CONFIG: Record<number, IDealsArticleConfig> = {
  329380: {
    // Семейная ипотека: последние изменения
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  282810: {
    // Пять правил для сделок с маткапиталом
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  328012: {
    // Налоговый вычет за недвижимость: что, кому и сколько положено
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  336741: {
    // Как выписать человека из квартиры: инструкция для собственника
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  287228: {
    // Как разделить имущество при разводе: основные правила
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  306977: {
    // Типовые договоры — все шаблоны
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  336684: {
    // Как выделить детские доли при покупке жилья с маткапиталом
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  327334: {
    // Как проходит сделка по продаже квартиры
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  336463: {
    // Продажа квартиры с долями несовершеннолетних детей
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  302704: {
    // Как правильно торговаться при покупке квартиры: инструкция для покупателя
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  336381: {
    // Как платить налог по новым правилам при продаже жилья
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
  306966: {
    // Договор купли-продажи квартиры
    formTitle: 'Планируете сделку с недвижимостью?',
    formSubtitle: 'Поможем найти покупателя, подготовим документы и обеспечим безопасность сделки',
  },
};

export const DEALS_BANNER_TEXTS: Record<TDealsBannerVariant, { title: string; buttonText: string }> = {
  sell: { title: 'Продайте квартиру без лишних хлопот', buttonText: 'Оставить заявку' },
  buy: { title: 'Подберём агента для безопасной покупки', buttonText: 'Оставить заявку' },
  'complex-deal': { title: 'Сложная сделка? Поможем провести её безопасно', buttonText: 'Оставить заявку' },
};

/**
 * Возвращает конфиг статьи для фичи "Сделка", если статья в неё включена
 */
export const getDealsArticleConfig = (postId: number): IDealsArticleConfig | undefined => DEALS_CONTENT_CONFIG[postId];
